export const childsPanel = [
  {
    path: "panelDeControl",
    name: "admin-panel-de-control",
    component: () =>
      import(
        /* webpackChunkName: "panelDeControl-panel" */ "@/modules/admin/pages/panelDeControl/Panel.vue"
      ),
  },
];
